import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonLock12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPersonLock12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 2a1.5 1.5 0 0 1 1.5 1.5h1a2.5 2.5 0 1 0-4.167 1.863A4 4 0 0 0 1 9v2h3.5v-1H2V9a3 3 0 0 1 2.5-2.959V4.915A1.5 1.5 0 0 1 5 2m3 3a1 1 0 0 1 1 1H7a1 1 0 0 1 1-1M6 6a2 2 0 1 1 4 0v.085A1.5 1.5 0 0 1 11 7.5v2A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-2a1.5 1.5 0 0 1 1-1.415zm0 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm2.5 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonLock12);
